import { motion } from 'framer-motion';

export const ValuePropSection = () => {
  return (
    <section className="py-20 md:py-28 bg-brand-sage/10" data-testid="value-prop-section">
      <div className="section-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto text-center"
        >
          <h2 className="font-manrope text-3xl md:text-4xl lg:text-5xl font-bold text-text-primary tracking-tight mb-8">
            Un plan nutricional que se adapta a su vida
          </h2>
          <p className="text-text-secondary text-lg md:text-xl leading-relaxed">
            Cada animal es único. En REALimenta diseñamos una alimentación natural personalizada 
            según su edad, estado de salud, actividad, preferencias y objetivos. Y lo más importante: 
            te acompañamos con seguimiento y ajustes para que sea fácil de aplicar, estés en Málaga 
            o en cualquier punto de España.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default ValuePropSection;
